<template>
    <div class="apiconfigure">
        <div class="title">
            <i></i>
            <span>在线文档</span>
        </div>
        <el-form :inline="true" class="search-common-box">
            <el-form-item label="文档名称">
                <el-input placeholder="请输入" v-model="search.name"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="warning" @click="current=1;getList()">查询</el-button>
            </el-form-item>
        </el-form>
        <div class="table-content" v-if="mainInfo.isOpenApi==1">
            <el-table ref="singleTable" border :stripe='true' :data="tableData" style="width: 100%" v-loading="listLoading">
                <el-table-column type="index" width="100" align="center"></el-table-column>
                <el-table-column property="name" label="文档名称" align="center"></el-table-column>
                <el-table-column label="文档地址" width='160px' align="center">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary" size='small' @click="openDetail(scope.row)">详情</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page.sync='current' background layout="total,prev, pager, next" :page-size='10' @current-change="getList" :total="total">
            </el-pagination>
        </div>
        <div class="content" v-if="mainInfo.isOpenApi==0">
            <div class="no">
                <img src="@static/images/no.png" alt="">
                <span>该功能暂未开放，如需了解请联系商务人员</span>
            </div>
        </div>
    </div>
</template>
<script>
//当前实例组件

export default {
    data: () => ({
        listLoading:false,
        tableData:[],
        current:1,
        total:0,
        search:{},//查询参数
        mainInfo:{}

    }),
    components: {

    },
    created() {
        console.log()
        this.queryMechanInfo();
    },
    methods: {
        //获取主体信息
        queryMechanInfo:function(){
            this.$http({
                url: '/master/mechan/queryMechanInfo',
                type: 'put',
                params:{},
            }).then((res)=> {
                this.mainInfo = res.data;
                if(this.mainInfo.isOpenApi==1) {
                    this.getList();
                }
            })
        },
        getList(){
            this.listLoading = true;
            const params = Object.assign({},this.search);
            params.pageSize = 10;
            params.pageNum = this.current;
            this.$http({
                url: '/master/mechan/queryMechanDoc',
                type: 'put',
                params:params,
            }).then((res)=> {
                this.listLoading = false;
                this.tableData = res.data;
                this.total = res.total;
            })
        },
        openDetail(item) {
            this.$router.push({
                path:"./documentDetail",
                query:{id:item.id}
            })
        }
    },
    mounted() {

    }
};
</script>
<style lang="scss">
@import "./apiCommon.scss";
</style>
